import { render, staticRenderFns } from "./record_list.vue?vue&type=template&id=92a4c182&scoped=true"
import script from "./record_list.vue?vue&type=script&lang=ts"
export * from "./record_list.vue?vue&type=script&lang=ts"
import style0 from "./record_list.vue?vue&type=style&index=0&id=92a4c182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a4c182",
  null
  
)

export default component.exports